import { AppSession } from "../AppSession"
import { AppStorage } from "../AppStorage"
import { AtivoModel } from "../model/AtivoModel"
import { TipoAtivoConstants } from "../TipoAtivoConstants"

export class RecomendacaoAtivoProvider {
    async salvaItemFavorito(item: AtivoModel, tipoAtivo: String) {
        let lista: Array<Number> = await this.getListaFavoritos(tipoAtivo)
        let itemNaLista = false
        if (lista.length > 0) {
            for (let i = 0; i < lista.length; i++) {
                if (lista[i] == item.id) {
                    itemNaLista = true
                    if (!item.favorito) {
                        lista.splice(i, 1)
                    }
                }
            }
        }
        if (!itemNaLista) {
            lista.push(item.id)
        }
        await AppStorage.set(this.getChaveSessaoPorTipoAtivo(tipoAtivo), lista)
    }
    
    getChaveSessaoPorTipoAtivo(tipoAtivo) {
        switch (tipoAtivo) {
            case TipoAtivoConstants.TIPO_BOLSA: return AppSession.CHAVE_LISTA_FAVORITOS_RECOMENDACAO_BRASIL;
            case TipoAtivoConstants.TIPO_EUA: return AppSession.CHAVE_LISTA_FAVORITOS_RECOMENDACAO_EUA;
            case TipoAtivoConstants.TIPO_CRIPTOMOEDAS: return AppSession.CHAVE_LISTA_FAVORITOS_RECOMENDACAO_CRIPTOMOEDAS;
            case TipoAtivoConstants.TIPO_FUNDOS_IMOBILIARIOS: return AppSession.CHAVE_LISTA_FAVORITOS_RECOMENDACAO_FUNDOS_IMOBILIARIOS;
            case TipoAtivoConstants.TIPO_FUNDOS_INDICE: return AppSession.CHAVE_LISTA_FAVORITOS_RECOMENDACAO_FUNDOS_INDICE;
            case TipoAtivoConstants.TIPO_INDICES: return AppSession.CHAVE_LISTA_FAVORITOS_RECOMENDACAO_INDICES;
        }
    }
    
    async getListaFavoritos(tipoAtivo: String) {
        let lista: Array<Number> = await AppStorage.get(this.getChaveSessaoPorTipoAtivo(tipoAtivo))
        if (!lista) {
            lista = []
        }
        return lista
    }

    async checkIsFavorite(tipoAtivo, idAtivo) {
        const list: Array<Number> = await this.getListaFavoritos(tipoAtivo)
        for (let id of list) {
            if (id == idAtivo) {
                return true
            }
        }
        return false
    }
}